"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = require('react');

var RibbonSpoolDetails = require('./RibbonSpoolDetails');

var ProductDetailsWrapper = require('./ProductDetailsWrapper');

var Space = require('./Space');

var PrintJob = require('../../PrintJob');

var RibbonSpool = require('../../../products/components/RibbonSpool');

var _require = require('../../helpers'),
    isLetterpressComponent = _require.isLetterpressComponent,
    isRibbon = _require.isRibbon;

function LetterpressRibbonDetails(props) {
  var printJob = props.printJob,
      options = props.options,
      printer = props.printer,
      componentSettings = props.componentSettings;
  var lpProductsWithRibbon = [];
  var digitalProductsWithRibbon = [];
  printJob.products.forEach(function (product) {
    if (product.components.some(function (component) {
      return component.acc_ribbon && component.acc_ribbon !== 'None' && isLetterpressComponent(component);
    })) {
      lpProductsWithRibbon.push(product);
    } else if (product.components.some(function (component) {
      return component.acc_ribbon && component.acc_ribbon !== 'None' && !isLetterpressComponent(component);
    }) || product.components.some(function (component) {
      return Object.prototype.isPrototypeOf.call(RibbonSpool.prototype, component);
    })) {
      digitalProductsWithRibbon.push(product);
    }
  });
  var return_value = [];

  if (lpProductsWithRibbon.length) {
    var params = JSON.parse(JSON.stringify(printJob));
    var pseudoPrintJob = new PrintJob(_objectSpread(_objectSpread({}, params), {}, {
      products: lpProductsWithRibbon
    }));
    return_value.push( /*#__PURE__*/React.createElement(Space, {
      n: 1
    }));
    return_value.push( /*#__PURE__*/React.createElement(ProductDetailsWrapper, {
      key: "lp-products-ribbon",
      printJob: pseudoPrintJob,
      filterFunction: isRibbon,
      RenderComponent: RibbonSpoolDetails,
      options: options,
      componentSettings: componentSettings,
      printer: printer
    }));
    return_value.push( /*#__PURE__*/React.createElement(Space, {
      n: 1
    }));
  }

  if (digitalProductsWithRibbon.length) {
    var _params = JSON.parse(JSON.stringify(printJob));

    var _pseudoPrintJob = new PrintJob(_objectSpread(_objectSpread({}, _params), {}, {
      products: digitalProductsWithRibbon
    }));

    return_value.push( /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("br", null), 'Other Ribbon Spools Included in Shipment:', /*#__PURE__*/React.createElement("br", null)));
    return_value.push( /*#__PURE__*/React.createElement(ProductDetailsWrapper, {
      key: "lp-products-ribbon",
      printJob: _pseudoPrintJob,
      filterFunction: isRibbon,
      RenderComponent: RibbonSpoolDetails,
      options: options,
      componentSettings: componentSettings,
      printer: printer
    }));
  }

  return return_value;
}

module.exports = LetterpressRibbonDetails;